<div
  data-qa="org-picker"
  id="org-picker"
  class="picker flex flex-col"
  (mouseenter)="activateOrgDropDown()"
  (mouseleave)="deactivateOrgPicker()">
  <span class="picker-header">Organization</span>
  <div
    data-qa="selected-org-name"
    class="picker-name">
    <span>{{ selectedOrg?.name | linkShort: 15 }}</span>
    <app-all-icons [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25;px-[0.5rem];'"/>
  </div>
  @if (showOrgPicker) {
    <div
      @fadeInOut
      class="picker-dropdown flex flex-col items-center content-center">
      <div class="autocomplete-input">
        <app-input
          data-qa="org-picker-search-input"
          [formControl]="searchOrgControl"
          [placeholder]="'Search organization...'"
          [suffixFirstIcon]="'close.svg'"
          (suffixFirstIconEmitter)="resetOrgInputValue()">
        </app-input>
      </div>
      <div class="picker-list flex flex-col items-center content-center">
        @if (isNewOrgCanBeCreated) {
          <div
            data-qa="new-org-btn-in-picker"
            class="flex flex-col items-center content-center list-block clickable"
            (click)="createOrgEmitter.emit()">
            <span class="list-subheader flex flex-row items-center justify-start flex-wrap gap-[0.25rem] main-8">
              <app-all-icons [iconNameAndStyling]="'plus.svg; icon-size-1p25'"/>
              <span class="bold400 font-3">Organization</span>
            </span>
          </div>
        }
        @for (org of selectedOrgOptions | async; track org) {
<!--          TODO: Fix using of list-* css classes-->
          <div
            [attr.data-qa]="'org-name-' + org.organization.name"
            class="flex flex-col items-center content-center list-block bg-main-2-hover"
            [class.bg-black-2]="org.organization.uuid === selectedOrg.uuid"
            (click)="orgSelectionEmitter.emit(org)">
            <span class="list-subheader flex flex-row items-center justify-start flex-wrap gap-[0.25rem]">
              <span class="bold400 font-3">{{ org.organization.name }}</span>
            </span>
          </div>
        }
      </div>
    </div>
  }
</div>
